const compareBuild = require('./compare-build')
const rsort = (list, loose) => list.sort((a, b) => compareBuild(b, a, loose))
module.exports = rsort



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/rsort.js
// module id = 2458
// module chunks = 0